module.exports = __webpack_public_path__ + "assets/img/youshi3.40ce57b0.png";